import { t } from "i18next"
import ValidationsCommon from "../../../utils/Validations";
const Validations = () => ({
    ...ValidationsCommon(),
    editQ: (errors, value) => {
        if (!value) {
            errors.editQ = (t("Required field", {ns: "messages"}));
        } else if (value < 1) {
            errors.editQ = (t("Укажите не менее 1 резерва", {ns: "messages"}));
        }
    },
    reasonDescription: (errors, value) => {
        if (!value) {
            errors.reasonDescription = (t("Required field", {ns: "messages"}));
        } else if(value.length < 3){
            errors.reasonDescription = (t("Слишком короткое основание", {ns: "messages"}));
        } else if (
            !/^[^<>]{1,300}$/g.test(
                value
            )
        ) {
            errors.reasonDescription = (t("Основание содержит запрещенный контент", {ns: "messages"}));
        }
    },
});

export default Validations;